import { useEffect, useState } from "react";
import api from "@/lib/api";

const COLORS = {
  "election.created": "#4ade80", "election.edited": "#facc15", "election.published": "#60a5fa",
  "election.closed": "#f87171", "election.deleted": "#f87171", "voters.imported": "#a78bfa",
  "invitations.sent": "#22d3ee", "invitations.resent": "#22d3ee", "results.exported": "#fbbf24",
  "position.added": "#34d399", "position.edited": "#facc15", "position.removed": "#f87171",
  "candidate.added": "#34d399", "candidate.edited": "#facc15", "candidate.removed": "#f87171",
  "winner.resolved": "#c084fc", "winner.cleared": "#fbbf24", "runoff.created": "#2dd4bf",
  "reminders.sent": "#38bdf8",
};

export default function AuditTab({ electionId }) {
  const [logs, setLogs] = useState(null);
  useEffect(() => { api.get(`/elections/${electionId}/audit`).then(({ data }) => setLogs(data)); }, [electionId]);

  return (
    <div data-testid="audit-log" className="bg-[#09090B] text-zinc-300 font-mono text-sm rounded-md p-6 overflow-x-auto">
      <div className="text-zinc-600 mb-4 text-xs">// IMMUTABLE AUDIT TRAIL — {logs?.length || 0} EVENTS</div>
      {!logs ? (
        <div className="text-zinc-600">loading…</div>
      ) : logs.length === 0 ? (
        <div className="text-zinc-600">No events recorded yet.</div>
      ) : (
        <div className="space-y-2">
          {logs.map((l) => (
            <div key={l.id} data-testid={`audit-${l.id}`} className="flex flex-wrap gap-x-3 gap-y-0.5 leading-relaxed">
              <span className="text-zinc-600">{new Date(l.timestamp).toISOString().replace("T", " ").slice(0, 19)}</span>
              <span className="font-bold" style={{ color: COLORS[l.event] || "#a1a1aa" }}>{l.event}</span>
              <span className="text-zinc-500">by {l.actor}</span>
              {l.metadata && Object.keys(l.metadata).length > 0 && (
                <span className="text-zinc-600">{JSON.stringify(l.metadata)}</span>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
